import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import { BRANDS_CATEGORY_ID } from "@faire/help-center-utils/consts/BRANDS_CATEGORY_ID";
import { getLatestDataUpdatedAt } from "@faire/help-center-utils/lib/getLatestDataUpdatedAt";
import { localeString } from "@faire/help-center-utils/lib/localeString";
import fetchCategoryArticlesByCategoryId, { build as CategoryArticlesRequestKey, QueryParameters as ICategoryArticlesQueryParams } from "@faire/web-api/api/zendesk/locale/categories/categoryId/articles/get";
import { useQueries } from "@tanstack/react-query";
export var useAllCategoryArticles = function useAllCategoryArticles(categories) {
  var categoriesArticlesResponses = useQueries({
    queries: categories.map(function (category) {
      var categoryParams = ICategoryArticlesQueryParams.build({
        label_names: category.id === BRANDS_CATEGORY_ID ? "popular-maker" : "popular-retailer"
      });
      return {
        queryKey: [CategoryArticlesRequestKey(localeString, "".concat(category.id), categoryParams)],
        queryFn: function queryFn() {
          return fetchCategoryArticlesByCategoryId(localeString, "".concat(category.id), categoryParams);
        },
        enable: categories.length > 0
      };
    })
  });
  var isLoading = categoriesArticlesResponses.some(function (queryResult) {
    return queryResult.isLoading;
  });
  var allDataUpdatedAt = categoriesArticlesResponses.map(function (queryResult) {
    return queryResult.dataUpdatedAt;
  });
  var dataUpdatedAt = getLatestDataUpdatedAt(allDataUpdatedAt);
  return {
    categoriesArticlesResponses: categoriesArticlesResponses,
    isCategoriesArticlesLoading: isLoading,
    categoriesArticlesDataUpdatedAt: dataUpdatedAt
  };
};